import Container from './Container';

export const PageRenderingState = Symbol('PageRenderingState');

export enum PageRenderingStateValue {
  ServerSideRendering,
  ClientSideRendering,
}

/**
 * !!!WARNING!!!
 *
 * This function creates a completely NEW container. It does NOT return a previously created instance.
 * By calling it, you should be absolutely certain that you need a new container instance.
 *
 * DO YOU REALLY NEED A NEW CONTAINER?
 */
const createContainer = (
  pageRenderingState: PageRenderingStateValue = PageRenderingStateValue.ClientSideRendering,
): Container => {
  const container = new Container();

  container.bind<PageRenderingStateValue>(PageRenderingState).toConstantValue(pageRenderingState);

  return container;
};

export default createContainer;
